<div class="main-container">
  <div
    class="export-table"
    id="queue"
    cdkDropList
    [cdkDropListData]="profiles"
    (cdkDropListDropped)="drop($event)"
  >
    <div class="h-100">
      <app-table-profile-export-queue
        [profiles]="profiles"
        (profileRemovedFromQueue)="onProfileRemovedFromQueue($event)"
      ></app-table-profile-export-queue>
    </div>
  </div>
  <div class="export-controls export-controls-background">
    <div class="anonym-employee">
      <label for="anonymizeEmployee" class="w-50">{{
        "profile_export.anonymize_employee" | translate
      }}</label>
      <div class="form-check form-switch centered-switch w-50">
        <input
          [(ngModel)]="anonymizeEmployees"
          id="anonymizeEmployee"
          class="form-check-input"
          type="checkbox"
          role="switch"
        />
      </div>
    </div>
    <div class="alternate-project-name">
      <label for="alternativeProjectName" class="w-50">{{
        "profile_export.alternative_project_name" | translate
      }}</label>
      <div class="form-check form-switch centered-switch w-50">
        <input
          [(ngModel)]="useAlternateProjectName"
          id="alternativeProjectName"
          class="form-check-input"
          type="checkbox"
          role="switch"
        />
      </div>
    </div>
    <div class="display-project-description">
      <label for="displayProjectDescription" class="w-50">{{
        "profile_export.display_project_description" | translate
      }}</label>
      <div class="form-check form-switch centered-switch w-50">
        <input
          [(ngModel)]="displayProjectDescription"
          id="displayProjectDescription"
          class="form-check-input"
          type="checkbox"
          role="switch"
        />
      </div>
    </div>
    <div class="template">
      <label for="template" class="w-50"> {{ "profile_export.template" | translate }}</label>
      <select id="template" [(ngModel)]="templateToUse" class="template-select w-50">
        <option value="gloster_pdf_template">Gloster template</option>
        <option value="minero_pdf_template">Gloster-Minero template</option>
        <option value="lanoga_pdf_template">Gloster-Lanoga template</option>
        <option value="p92_pdf_template">Gloster-P92 template</option>
        <option value="cloud_pdf_template">Gloster Cloud template</option>
      </select>
    </div>
    <div class="contact-email">
      <label for="contactEmail" class="w-50">
        {{ "profile_export.contact_email" | translate }}</label
      >
      <input id="contactEmail" [(ngModel)]="contactEmail" type="email" class="w-50" />
    </div>
    <div class="mt-auto ms-auto">
      <button
        (click)="exportToPdf()"
        class="btn primary-btn"
      >
        {{ "profile_export.export" | translate }}
      </button>
    </div>
  </div>
</div>

<ngb-toast
  *ngIf="showErrorToast"
  class="error-toast bg-danger text-light"
  [autohide]="true"
  (hidden)="showErrorToast = false"
  [delay]="4000"
  >{{ errorMessageKey | translate }}
</ngb-toast>
